import React from "react";
import { Box, Button, SimpleGrid } from "@chakra-ui/react";

import { fetchInstallerLink } from "api/webservice/resources";
import { useToast } from "hooks";
import { useModal } from "context/modal";

const InstallerButton: React.FC = () => {
  const { openModal, closeModal, setTitle, setContent } = useModal()!;
  const toast = useToast();

  const isWindows = // @ts-ignore
    navigator?.userAgentData?.platform || navigator?.platform || "unknown";

  const handleClick = (): void => {
    closeModal();
    fetchInstallerLink()
      .then(installerLink => window.open(installerLink, "_blank"))
      .catch(err => {
        console.log(err);
        toast({
          title: "Something went wrong",
          description: "Could not retrieve the download link.",
          status: "error"
        });
      });
  };

  const openDownloadModal = () => {
    setTitle("Download Charisma");
    setContent(
      <>
        <Box mb="1rem">
          Charisma works best on a machine with a relatively new graphics card
          and plenty of memory.
          <br />
          If you do not have such a machine, please consider using the
          in-browser game interface.
        </Box>
        <SimpleGrid columns={2} gap={6}>
          <Button size="sm" onClick={handleClick} variant="blue">
            I Understand
          </Button>
          <Button size="sm" onClick={closeModal}>
            Never Mind
          </Button>
        </SimpleGrid>
      </>
    );
    openModal();
  };

  return (
    <Button variant="blue" hidden={!isWindows} onClick={openDownloadModal}>
      Install Charisma
    </Button>
  );
};

export default InstallerButton;
